define('views/blocks/paymentModeProviders/OgoneBrandsView',['underscore', 'app', 'ApiRequest',
    'PaymentModeSelectionBoardView',
    'template!blocks/paymentmodes/ogone-brands',
],function(_, app, ApiRequest,
    PaymentModeSelectionBoardView,
    ogoneBrandsTemplate
){
    var selectedBrand;

    return PaymentModeSelectionBoardView.extend({
        eventsOverride: {
            'change [name=brand]': 'changeBrand',
            'click .payment-mode__selection__brand': 'onClickLabelSelection',
        },
        name:'ogone-brands',
        renderInner: function () {
            var title = this.paymentMode.getAddBrandTitle();
            return ogoneBrandsTemplate({
                title: title,
                brands: this.getBrands(),
            });
        },
        getBrands: function () {
            var view = this,
                paymentMode = view.paymentMode;
            return paymentMode.getBrands();
        },
        onClickLabelSelection: function (e) {
            var radio = $(':radio',e.currentTarget).get(0);
            if(e.originalEvent.target !== radio && radio.checked){
                this.selectBrand(radio.value);
            }
        },
        changeBrand:function(e){
            this.selectBrand(e.currentTarget.value);
        },
        selectBrand:function(id_payment_brand){
            var view = this,
                paymentMode = view.paymentMode,
                selectedBrand = view.getBrands().findWhere({
                    id_payment_brand:id_payment_brand
                }),
                directlink = selectedBrand.get('directlink'),
                brand = selectedBrand.get('brand');
            paymentMode.setOption('cbBrand',brand,true);
            paymentMode.setOption('directlink',directlink?1:0,true);
            view.close();
        },
    });
});
